import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './reservation-availability.actions';
import { ReservationAvailabilityState } from './reservation-availability.state';

/**
 * reservationAvailability initial state
 */
export const reservationAvailabilityInitialState: ReservationAvailabilityState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for ReservationAvailability Store
 */
export const reservationAvailabilityReducerFeatures: ReducerTypes<ReservationAvailabilityState, ActionCreator[]>[] = [
  on(actions.setReservationAvailability, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateReservationAvailability, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetReservationAvailability, () => reservationAvailabilityInitialState),

  on(actions.cancelReservationAvailabilityRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failReservationAvailability, (state, payload) =>
    asyncStoreItemAdapter.failRequest(state, payload.requestId)
  ),

  on(actions.setReservationAvailabilityFromApi, actions.updateReservationAvailabilityFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * ReservationAvailability Store reducer
 */
export const reservationAvailabilityReducer = createReducer(
  reservationAvailabilityInitialState,
  ...reservationAvailabilityReducerFeatures
);
